export enum UserTypeEnum {
  AGENT = "AGENT",
  CANDIDATE = "CANDIDATE",
  MANAGER = "MANAGER",
  ANONYMOUS = "ANONYMOUS",
}
export enum DeliveryMethodEnum {
  SMS = "SMS",
}

export enum OtpContextEnum {
  FIRST_LOGIN = "FirstLogin",
  FORGOT_PASSWORD = "ForgotPassword",
  PublicSharing = "PublicSharing",
  //PHKL Custom -s
  CW_CREATE_ACCOUNT = "CWCreateAccount", //Only for otp use
  CW_EDIT_MOBILE = "CWEditMobile", //Only for otp use
  CW_FORGOT_PASSWORD = "CWForgotPassword", //Only for otp use
  //PHKL Custom -e
}

export enum GetOTPLangOption {
  en = "en",
  zh = "zh",
}
